import React, { useState } from "react";

import {
    LinearProgress,
    OutlinedInput,
} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,TableContainer,
      Paper,
    TableCell, IconButton, Divider, FormHelperText
} from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import StudentService from "./Locality/Service/studentService"
import SpecialObservationService from "./Locality/Service/specialObservationService"
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useContext, useEffect } from 'react';
import { useTheme } from "@material-ui/styles";
import {
    ResponsiveContainer,
    ComposedChart,
    AreaChart,
    LineChart,
    Line,
    Area,
    PieChart,
    Pie,
    Cell,
    YAxis,
    XAxis,
} from "recharts";
import mock from "./mock";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import BigStat from "./components/BigStat/BigStat";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dialogPaper: {
        borderRadius: 14,
        width: 400,
        maxWidth: '95vw',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #eef1f5',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    dialogBody: {
        padding: theme.spacing(2.5),
    },
    fieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
    },
    sectionLabel: {
        fontWeight: 700,
        color: '#46566b',
        fontSize: '0.72rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: theme.spacing(1.25),
    },
    formSection: {
        marginBottom: theme.spacing(2.5),
    },
    dialogFooter: {
        padding: theme.spacing(1.5, 2.5),
        borderTop: '1px solid #eef1f5',
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
}));
export default function Teacher() {
    const tableHeaders = ['Class', 'Section', 'Date', 'Special Observation', 'Edit', 'Delete', 'Add More'];
    const classes = useStyles();
    const [teacherList, setTeacherList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [age, setAge] = React.useState('');
    const [studentList, setStudentList] = useState([]);
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [specialObservationList, setSpecialObservationList] = useState([]);
    const [filterClassId, setFilterClassId] = useState("");
    const [filterSectionId, setFilterSectionId] = useState("");
    const [filterSectionList, setFilterSectionList] = useState([]);
    const [observation, setObservation] = useState({
        studentId: '',
        date: '',
        specialObservation: '',
        classId: '',
        sectionId: '',
    })
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        studentId: Yup.string().required('Student Name is required'),
        date: Yup.string().required('Date is required'),
        specialObservation: Yup.string(),
       
    });
    useEffect(() => {
        // getStudentList();
        getSpecialObservationList();
        getAddClassList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
            setAddClassList([]);
            setStudentList([]);
            setSpecialObservationList([]);
            // setClassNameList([]);
        }
    }, []);
    const getStudentList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getSpeList = { classId: event.target.value };
        const effectiveSectionId = obj?.sectionId || formik?.values?.sectionId || '';
        if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
        StudentService.getAllStudentById(userDetails.schooleId,
            getSpeList
        ).then((res) => {
            const studentDetails = res.map(res => {

                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            })
            setStudentList(studentDetails);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const handleOpen = (status) => {
        if(status){
            setObservation({
                studentId: '',
                date: '',
                specialObservation: '',
                classId: '',
                sectionId: '',
        })
        }
     
          setOpen(true);
      };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleChangePage=(event, newpage) =>{
        setpg(newpage);
    }
    
    const handleChangeRowsPerPage=(event)=> {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const getFilterSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setFilterSectionList([]);
            return;
        }
        SectionService.findSectionList({ schooleId: userDetails.schooleId, classId })
            .then((res) => {
                const list = (Array.isArray(res) ? res : []).filter((x) => x?.status !== false);
                setFilterSectionList(list);
                // Clear invalid section
                if (filterSectionId && !list.some((s) => String(s?._id) === String(filterSectionId))) {
                    setFilterSectionId("");
                }
            })
            .catch(() => setFilterSectionList([]));
    };

    const onFilterClassChange = (e) => {
        const id = e.target.value;
        setFilterClassId(id);
        setFilterSectionId("");
        setpg(0);
        getFilterSectionListByClass(id);
        getSpecialObservationList({ classId: id, sectionId: "" });
    };

    const onFilterSectionChange = (e) => {
        const id = e.target.value;
        setFilterSectionId(id);
        setpg(0);
        getSpecialObservationList({ sectionId: id });
    };
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };
    const getSpecialObservationList = (nextFilters = {}) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const classId = nextFilters.classId !== undefined ? nextFilters.classId : filterClassId;
        const sectionId = nextFilters.sectionId !== undefined ? nextFilters.sectionId : filterSectionId;
        SpecialObservationService.getAllSpecialObservation(userDetails.schooleId, {
            classId: classId || undefined,
            sectionId: sectionId || undefined,
        }).then((res) => {
            setSpecialObservationList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            setAddClassList((Array.isArray(res) ? res : []).filter((x) => x?.status !== false));
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getSectionListByClass = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            return;
        }
        SectionService.findSectionList({ schooleId: userDetails.schooleId, classId })
            .then((res) => {
                const list = (Array.isArray(res) ? res : []).filter((x) => x?.status !== false);
                setSectionList(list);
                const currentSectionId = String(formik.values.sectionId || "");
                if (currentSectionId && !list.some((s) => String(s?._id) === currentSectionId)) {
                    formik.setFieldValue("sectionId", "");
                }
            })
            .catch(() => setSectionList([]));
    };
    const editSpecialObservation = (observation, status) => {
       
        const obj = JSON.parse(JSON.stringify(observation));
        obj.studentId = observation.studentId ? observation.studentId._id : '';
        // obj.classId = observation.classId ? observation.classId._id : '';
        obj.classId = observation.classId ? observation.classId._id :'';
        obj.sectionId = observation.sectionId ? (observation.sectionId._id || observation.sectionId) : '';

        getSectionListByClass(obj.classId);
        getStudentList( { target: { value: obj.classId } }, obj);
        getAddClassList({target: { value: obj.superActivityId }}, obj)
        
         setObservation(obj);
        if(status){
           delete obj._id;
        }
        handleOpen(false);
    }
    const deleteSpecialObservation = (observationdelete) => {
        if (observationdelete) {
            SpecialObservationService.deleteSpecialobservation(observationdelete).then((res) => {
                getSpecialObservationList();
            }).catch((err) => {
            });
        }
    };
    const formik = useFormik({
        initialValues: observation,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
        
            if (observation._id) {
                SpecialObservationService.upadeSpecialobservation(values).then((res) => {
                    handleClose();
                    getSpecialObservationList();
                    resetForm()
                    alert("Special Observation Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                SpecialObservationService.creteSpecialobservation(values).then((res) => {
                    getSpecialObservationList();
                    resetForm();
                    handleClose();
                    alert(" Special Observation Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });

    return (

        <>
            <PageTitle title="Special Observation" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Observation
            </Button>} />
            <Grid container spacing={2} style={{ marginBottom: 12 }}>
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Filter by Class</InputLabel>
                        <Select value={filterClassId} onChange={onFilterClassChange} label="Filter by Class">
                            <MenuItem value=""><em>None</em></MenuItem>
                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small" disabled={!filterClassId}>
                        <InputLabel>Filter by Section</InputLabel>
                        <Select value={filterSectionId} onChange={onFilterSectionChange} label="Filter by Section">
                            <MenuItem value=""><em>None</em></MenuItem>
                            {filterSectionList.map(({ _id, sectionName }) => (
                                <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0 dashboard-table-row-hover">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {(() => {
                                    // Group observations by student so each student's observations stay together
                                    const grouped = new Map();
                                    const base = Array.isArray(specialObservationList) ? specialObservationList : [];
                                    const list = base.filter((o) => {
                                        if (filterClassId && String(o?.classId?._id || o?.classId || "") !== String(filterClassId)) return false;
                                        if (filterSectionId && String(o?.sectionId?._id || o?.sectionId || "") !== String(filterSectionId)) return false;
                                        return true;
                                    });

                                    // Sort by student name then date desc (keeps blocks stable)
                                    const sorted = [...list].sort((a, b) => {
                                        const aName = `${a?.studentId?.firstName || ""} ${a?.studentId?.lastName || ""}`.trim().toLowerCase();
                                        const bName = `${b?.studentId?.firstName || ""} ${b?.studentId?.lastName || ""}`.trim().toLowerCase();
                                        if (aName !== bName) return aName.localeCompare(bName);
                                        const aDate = String(a?.date || "");
                                        const bDate = String(b?.date || "");
                                        return bDate.localeCompare(aDate);
                                    });

                                    for (const obs of sorted) {
                                        const sid = obs?.studentId?._id || obs?.studentId || "unknown-student";
                                        const studentName = `${obs?.studentId?.firstName || ""} ${obs?.studentId?.lastName || ""}`.trim() || "—";
                                        const key = String(sid);
                                        if (!grouped.has(key)) grouped.set(key, { key, studentName, rows: [] });
                                        grouped.get(key).rows.push(obs);
                                    }

                                    const groupedArr = Array.from(grouped.values());
                                    const pageGroups = groupedArr.slice(pg * rpg, pg * rpg + rpg);

                                    return pageGroups.flatMap((g) => [
                                        <TableRow key={`student-${g.key}`} className="dashboard-table-no-hover" style={{ backgroundColor: "#7a7f7a" }}>
                                            <TableCell colSpan={tableHeaders.length} style={{ color: "white", fontWeight: 700 }}>
                                                {g.studentName}
                                            </TableCell>
                                        </TableRow>,
                                        ...g.rows.map((observation) => (
                                            <TableRow key={observation._id}>
                                                <TableCell className="pl-3 fw-normal">
                                                    {observation.classId ? observation.classId.className : ''}
                                                </TableCell>
                                                <TableCell className="pl-3 fw-normal">
                                                    {observation.sectionId ? (observation.sectionId.sectionName || observation.sectionId) : '—'}
                                                </TableCell>
                                                <TableCell className="pl-3 fw-normal">{observation.date}</TableCell>
                                                <TableCell className="pl-3 fw-normal">{observation.specialObservation}</TableCell>
                                                <TableCell>
                                                    <EditIcon style={{ cursor: 'pointer' }} onClick={() => editSpecialObservation(observation)} />
                                                </TableCell>
                                                <TableCell>
                                                    <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteSpecialObservation(observation)} />
                                                </TableCell>
                                                <TableCell>
                                                    <AddIcon style={{ cursor: 'pointer' }} onClick={() => editSpecialObservation(observation, true)} />
                                                </TableCell>
                                            </TableRow>
                                        )),
                                    ]);
                                })()}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 100000 ]}
                            count={Array.from(new Set(((() => {
                                const base = Array.isArray(specialObservationList) ? specialObservationList : [];
                                const filtered = base.filter((o) => {
                                    if (filterClassId && String(o?.classId?._id || o?.classId || "") !== String(filterClassId)) return false;
                                    if (filterSectionId && String(o?.sectionId?._id || o?.sectionId || "") !== String(filterSectionId)) return false;
                                    return true;
                                });
                                return filtered;
                            })()).map((o) => String(o?.studentId?._id || o?.studentId || 'unknown')))).length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} scroll="paper" PaperProps={{ className: classes.dialogPaper }}>
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {observation._id ? 'Edit Observation' : 'Add Observation'}
                    </span>
                    <IconButton size="small" onClick={handleClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent className={classes.dialogBody}>
                        <Box className={classes.formSection}>
                            <span className={classes.sectionLabel}>Class &amp; Student</span>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <span className={classes.fieldLabel}>Class</span>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        error={formik.touched.classId && Boolean(formik.errors.classId)}
                                    >
                                        <Select
                                            id="demo-simple-select"
                                            name="classId"
                                            displayEmpty
                                            value={formik.values.classId}
                                            onChange={e => {
                                                formik.setFieldValue("sectionId", "");
                                                formik.handleChange(e);
                                                getSectionListByClass(e.target.value);
                                                getStudentList(e);
                                            }}
                                        >
                                            <MenuItem value=""><em>Select Class</em></MenuItem>
                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.classId && formik.errors.classId && (
                                            <FormHelperText>{formik.errors.classId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <span className={classes.fieldLabel}>Section (Optional)</span>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled={!formik.values.classId || sectionList.length === 0}
                                    >
                                        <Select
                                            id="sectionName"
                                            name="sectionId"
                                            displayEmpty
                                            value={formik.values.sectionId || ""}
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                if (formik.values.classId) {
                                                    getStudentList({ target: { value: formik.values.classId } }, { sectionId: e.target.value || '' });
                                                }
                                            }}
                                        >
                                            <MenuItem value=""><em>All Sections</em></MenuItem>
                                            {sectionList.map(({ _id, sectionName }) => (
                                                <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <span className={classes.fieldLabel}>Student Name</span>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                                    >
                                        <Select
                                            id="studentName"
                                            name="studentId"
                                            displayEmpty
                                            value={formik.values.studentId}
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value=""><em>Select Student</em></MenuItem>
                                            {studentList.map(({ index, _id, studentName }) => (
                                                <MenuItem key={index} value={_id}>{studentName}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.studentId && formik.errors.studentId && (
                                            <FormHelperText>{formik.errors.studentId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>

                        <Divider />

                        <Box className={classes.formSection} style={{ marginTop: 20, marginBottom: 0 }}>
                            <span className={classes.sectionLabel}>Observation Details</span>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <span className={classes.fieldLabel}>Date</span>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        id="date"
                                        name="date"
                                        type="date"
                                        value={formik.values.date}
                                        onChange={formik.handleChange}
                                        error={formik.touched.date && Boolean(formik.errors.date)}
                                        helperText={formik.touched.date && formik.errors.date}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <span className={classes.fieldLabel}>Special Observation</span>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        id="specialObservation"
                                        name="specialObservation"
                                        placeholder="Write your observation..."
                                        type="text"
                                        multiline
                                        minRows={3}
                                        value={formik.values.specialObservation}
                                        onChange={formik.handleChange}
                                        error={formik.touched.specialObservation && Boolean(formik.errors.specialObservation)}
                                        helperText={formik.touched.specialObservation && formik.errors.specialObservation}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>

                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} className={classes.cancelBtn}>Cancel</Button>
                        <Button type="submit" variant="contained" className={classes.saveBtn}>
                            {observation._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


